const select = function (el: HTMLElement) {
  const range = document.createRange();
  range.selectNodeContents(el);

  const sel = window.getSelection();
  sel?.removeAllRanges();
  sel?.addRange(range);
};

export function copy(el: HTMLElement) {
  select(el);
  document.execCommand('copy');
}
